import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../ui/button';
import Spinner from '../ui/spinner';
import { closeModal } from './modals.utils';
import { ModalBase } from './modals-base';

export interface ConfirmDeleteModalProps {
  title?: React.ReactNode;
  description?: React.ReactNode;
  onClose?: () => void;
  onSubmit: () => Promise<void> | void;
}

export const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  title,
  description,
  onClose,
  onSubmit,
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = React.useState(false);
  const closeModalHandler = () => {
    closeModal();
    return onClose?.();
  };
  const submitHandler = async () => {
    try {
      setLoading(true);
      await onSubmit();
      closeModal();
    } finally {
      setLoading(false);
    }
  };
  return (
    <ModalBase className="max-w-96">
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-primary-lighter/40">
          <Spinner className="size-12 [&_*]:stroke-primary-dark" />
        </div>
      )}
      {typeof title === 'string' ? <h3 className="text-center text-md">{title}</h3> : title}
      {typeof title === 'string' ? (
        <p className="mt-6 text-center text-base text-text-secondary">{description}</p>
      ) : (
        description
      )}
      <div className="mt-8 grid grid-cols-2 gap-4">
        <Button onClick={closeModalHandler} variant="outline">
          {t('cancel')}
        </Button>
        <Button variant="destructive" onClick={submitHandler}>
          {t('delete')}
        </Button>
      </div>
    </ModalBase>
  );
};
